<template>
  <div class="h-100" v-bind:class="{'pt-5': resultPage.isMobile === true}">
    <div class="h-100">
      <div class="gallery-1 justify-content-center pb-20 h-100 ">
        <LoadingAnimation v-if="loading" animation-style="bars"></LoadingAnimation>

        <div class="container" v-if="complete === true">

          <div class="alert alert-info" v-if="output_too_large === true">
            {{ translate('File is too large for preview') }}
          </div>
          <div class="alert alert-warning" v-if="output_failed === true">
            {{ translate('Could not get file for preview') }}
          </div>
          <div class="card" v-if="output_too_large === false && output_failed === false">
            <div class="card-header font-weight-bold">{{ translate('Your generated hash') }}</div>
            <div class="card-body p-3 text-output " v-if="output_content">
              <div class="bg-hash p-3 br-8">
              <p class="font-weight-bold">hex: {{ output_content }}</p>
              <p>HEX: {{ output_content.toUpperCase() }}</p>
              <p>h:e:x: {{ macStyleHex(output_content)  }}</p>
              <p>base64: {{ base64(output_content)}}</p>
            </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../events/job.events";
import axios from 'axios';
import LoadingAnimation from "../../../../LoadingAnimation.vue";

function chunk(str, n) {
  var ret = [];
  var i;
  var len;

  for(i = 0, len = str.length; i < len; i += n) {
    ret.push(str.substr(i, n))
  }

  return ret
}

export default {
  name: "OutputHash",
  props: {},
  components: { LoadingAnimation },
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      output_content: '',
      output_too_large: false,
      output_failed: false
    };
  },
  mounted: function () {
    this.getOutputContent();
  },
  created: function () {
    this.getOutputContent();

    EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
      this.getOutputContent();
    });
  },
  filters: {

  },
  methods: {
    macStyleHex(value) {
      return chunk(value, 2).join(':');
    },
    base64(value) {
      const hexToBytes = (hex) => new Uint8Array(hex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
      const binaryData = hexToBytes(value);

      return btoa(String.fromCharCode.apply(null, binaryData));
    },
     getOutputContent() {
      if (this.output_content !== '') {
        return;
      }
      if (this.currentJob.state !== 'completed') {
        return;
      }

       if (this.outputId === 'no_output_id') {
         setTimeout(this.getOutputContent, 1000);

         return;
       }

      console.log(this.currentOutput);

      if (this.currentOutput.size > 2000000) {
        this.output_too_large = true;
        return;
      }

      if (typeof this.currentOutput.previewContent !== 'undefined') {
        this.output_content = this.currentOutput.previewContent;
        return;
      }

      let that = this;
      axios.get(this.currentOutput.uri).then((response) => {
        this.output_content = response.data;
        this.currentOutput.previewContent = response.data;
      }).catch(function (error) {
        that.output_failed = true;
      })
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.bg-hash {
  background: #CCF4DC;
}
</style>
